import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface UseTableDataProps<DataModel> {
  data: DataModel[] | undefined;
  isUninitialized: boolean;
  isLoading: boolean;
  isFetching: boolean;
  isSuccess: boolean;
  isError: boolean;
  noResultsDescription?: string;
}

export const useTableData = <DataModel>({
  data,
  isUninitialized,
  isLoading,
  isFetching,
  isSuccess,
  isError,
  noResultsDescription,
}: UseTableDataProps<DataModel>) => {
  const { t } = useTranslation();

  const noDataDescription: string = useMemo(() => {
    if (isUninitialized || isLoading || isFetching) {
      return t('Loading');
    } else if (isSuccess) {
      return noResultsDescription ? noResultsDescription : t('NoResults');
    } else if (isError) {
      return t('ErrorDescription');
    } else {
      return t('Unknown error');
    }
  }, [t, isUninitialized, isLoading, isFetching, isError, isSuccess, noResultsDescription]);

  const hasData = isSuccess && !!data?.length;

  return {
    hasData,
    noDataDescription,
  };
};
